export default "__VITE_ASSET__D0tGwG$N__"